<template>
  <div class="story-info">
    <h4>
      <a v-link="{ name: 'read-chapter', params: { story: story.id, chapter: 1} }">{{ story.title }}</a>
      <a v-if="story.chapters > 1" v-link="{ name: 'read-chapter', params: { story: story.id, chapter: story.chapters} }">&raquo;</a>
      <small>
        by {{ story.author }}
      </small>
    </h4>
    <p>{{ story.summary }}</p>
    <story-small-meta :story="story"></story-small-meta>
  </div>
</template>
<style>
  .story-info {
    margin: 10px;
    padding-bottom:10px;
    border-bottom: 1px solid #999;
  }
</style>
<script>
  import StorySmallMeta from 'components/StorySmallMeta';
  export default {
    props: ['story'],
    components: { StorySmallMeta },
  };
</script>



/** WEBPACK FOOTER **
 ** StoryInfo.vue?ae92f9ce
 **/